import { createLogger, format, transports } from 'winston';

import rollbar from 'utils/rollbar';

const httpTransportOptions = {
  host: 'http-intake.logs.datadoghq.com',
  path: `/api/v2/logs?dd-api-key=${process.env.DATADOG_API_KEY}&ddsource=nodejs&service=${process.env.NEXT_PUBLIC_DATADOG_SERVICE}&env=${process.env.NEXT_PUBLIC_HI_ENV}`,
  ssl: true,
};

const ddLogger = createLogger({
  level: 'info',
  exitOnError: false,
  format: format.combine(format.errors({ stack: true }), format.json()),
  transports: [new transports.Http(httpTransportOptions)],
});

export const serverLogger = {
  info: (message, ...args) => {
    rollbar.info(message, ...args);
    ddLogger.info(message, { ...args });
  },
  warn: (message, err = {}, ...args) => {
    rollbar.warn(message, err, ...args);
    ddLogger.warn(message, { ...args, error: err });
  },
  error: (message, err = {}, ...args) => {
    rollbar.error(message, err, ...args);
    ddLogger.error(message, { ...args, error: err });
  },
  critical: (message, err = {}, ...args) => {
    rollbar.critical(message, err, ...args);
    // datadog does not have a critical level
    ddLogger.error(message, { ...args, error: err });
  },
};
